import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'ghost'
    | 'danger'
    | 'dangerOutline'
    | 'saphir';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  iconButton?: boolean;
  children: ReactNode;
}

export default function ButtonComponent({
  variant = 'primary',
  size = 'md',
  loading = false,
  iconButton = false,
  children,
  className,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type as 'button' | 'submit' | 'reset'}
      className={clsx(
        styles.btn,
        styles[variant],
        styles[size],
        { [styles.loading]: loading, [styles.iconBtn]: iconButton },
        className,
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {children}
    </button>
  );
}

export type { ButtonProps };
export { ButtonComponent };
